import { Typography } from "@mui/material";
import { useNumberSerialiser } from "hooks/serialisers/numbers";

interface Props {
  amount: number;
}

export const InventoryCell = ({ amount }: Props) => {
  const { format } = useNumberSerialiser({ decimalPlaces: 0 });
  return (
    <Typography variant="body1Mono" sx={{ width: "100%" }}>
      {format(amount)}
    </Typography>
  );
};
